export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_359.f549d66e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};